import { MenuItem, Select } from "@mui/material";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { useTranslation } from "react-i18next";
import { DropdownAnswerSubtypeResponse } from "../../../../types/actionModule/subtypes/dropdownAnswerSubtype";


interface Props {
    state: SubtypeState
}

export default function DropdownAnswerEditorPreview(props: Props) {
    const { t } = useTranslation();

    const subtype = props.state.properties as Partial<DropdownAnswerSubtypeResponse>;

    return <Select
        label={t("actionModules.schedulingStrategy.repeatPattern.frequency")}
        value={0}
        size="small"
        fullWidth
        onChange={() => { }}
    >
        {
            subtype.checklistItems?.map((item, i) =>
                <MenuItem value={i}>{item.text}</MenuItem>
            ) ?? []
        }
    </Select>
}